import { render, staticRenderFns } from "./PublisherPicker.vue?vue&type=template&id=8cd08552&scoped=true"
import script from "./PublisherPicker.vue?vue&type=script&lang=ts"
export * from "./PublisherPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd08552",
  null
  
)

export default component.exports